import _ from 'lodash'
import RenderData from '../../RenderData'
import Render from './render/render'
import ChildRender from './render/childRender'
import Editor from './editor/editor'
import ChildEditor from './editor/childEditor'
import mainProps, { childProps } from './propsTemplate'
import RenderMode from './RenderMode'
import i18n from '@/i18n'

const name = 'Form'
const childName = name + 'Item'

const toolbarItems = [
  {
    tag: name,
    icon: 'icon-form',
    get label () {
      return i18n.t('microSite.form.name')
    },
    isShow: true, // todo may need replace with permission
    staticProps: {
      renderMode: RenderMode.normal
    }
  }
]

const renders = {
  [name]: Render,
  [childName]: ChildRender
}

const editors = {
  [name]: Editor,
  [childName]: ChildEditor
}

function getEditorTitle (renderData) {
  if (renderData.tag === name) {
    return i18n.t('microSite.form.name')
  } else {
    return i18n.t('microSite.form.label.formItemName')
  }
}

function createRenderData (tag, index, parent) {
  const data = {
    props: _.cloneDeep(mainProps)
  }
  const renderData = new RenderData(tag, data, -1, index, parent, [])
  return renderData
}

function createChildRenderData (parent) {
  const parentTag = parent.tag
  if (parentTag !== name) {
    return
  }
  const index = parent.children.length
  const data = {
    props: _.cloneDeep(childProps)
  }
  data.props.renderMode = parent.data.props.renderMode
  const renderData = new RenderData(childName, data, -1, index, parent)
  return renderData
}

const module = {
  name,
  toolbarItems,
  renders,
  editors,
  getEditorTitle,
  createRenderData,
  createChildRenderData
}

export default module

export { childName }
